import { ajaxSend } from '../utils';
export default function submiter(form) {
    const url = form.action;
    const formData = new FormData(form);
    ajaxSend({ url, formData })
        .then((response) => {
        processing(response);
        form.reset();
        // window.ym(56313895,'reachGoal', 'formSent');
    })
        .catch((err) => console.error(err));
    const processing = (pageSourceHtml) => {
        // form?.querySelector('.modal-form__title').classList.add('hide');
        console.log({
            pageSourceHtml
        });
        // form.parentElement.previousElementSibling.classList.add('hide');
        form.parentElement.parentElement.innerHTML = `
            <div class="col-24 column">
                <h2>Сообщение отправлено</h2>
                <p class="lead">Спасибо за ваше сообщение! Мы не можем ответить в данный момент. Мы свяжемся с вами в ближайшее рабочее время.</br>
                График работы:</br>
                ПН-ПТ: 8.00 - 16.30 </br>
                Обед: 12.00 - 12.30</br>
                СБ, ВС: выходные.</p>
            </div>
        `;
        // pageSourceHtml.indexOf('<div class="{$col-medium} justify-center column formPostedMessege">')
    };
}
;
